import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import Button from '@sorare/core/src/atoms/buttons/Button';
import { FOOTBALL_PLAY_RIVALS_DRAFT_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import useEvents from '@sorare/core/src/lib/events/useEvents';

import { Steps as RivalsDraftSteps } from 'components/rivals/draft/types';

import { BoostYourLineUp_footballRivalsLineup } from './__generated__/index.graphql';

type Props = { slug: string; myLineup: BoostYourLineUp_footballRivalsLineup };

export const BoostYourLineup = ({ slug, myLineup }: Props) => {
  const track = useEvents();

  const hasSupplyToProUpgrade = myLineup?.appearances?.find(
    appearance =>
      (!appearance.rarity || appearance.rarity === Rarity.common) &&
      appearance.player?.anyCardWithLivePrimaryOffer
  );

  if (hasSupplyToProUpgrade)
    return (
      <Button
        onClick={() =>
          track('Click Boost Rivals Lineup', {
            gameSlug: slug,
            lineupId: myLineup.id,
            sport: Sport.FOOTBALL,
          })
        }
        color="tertiary"
        size="medium"
        to={`${generatePath(FOOTBALL_PLAY_RIVALS_DRAFT_SLUG, {
          slug,
        })}?step=${RivalsDraftSteps.PRO_UPGRADE}`}
      >
        <FormattedMessage
          id="rivals.myLineups.boostLineup"
          defaultMessage="Upgrade Lineup"
        />
      </Button>
    );
  return null;
};

BoostYourLineup.fragments = {
  footballRivalsLineup: gql`
    fragment BoostYourLineUp_footballRivalsLineup on FootballRivalsLineup {
      id
      appearances {
        id
        player {
          slug
          anyCardWithLivePrimaryOffer(rarity: limited) {
            slug
          }
        }
        rarity
      }
    }
  ` as TypedDocumentNode<BoostYourLineUp_footballRivalsLineup>,
};
